import { PayoutDTO } from "../entity/PayoutDTO";

export interface PayoutDTOValidationObj {
  id: boolean;
  year: boolean;
  month: boolean;
  coachWage: boolean;
  coachTax: boolean;
  paid: boolean;
  trainingSchedule: boolean;
  coach: boolean;
  amount: boolean;
  hoursCnt: boolean;
  sessionsCnt: boolean;
}

export const payoutDTOValidationObjInit: PayoutDTOValidationObj = {
  id: true,
  year: true,
  month: true,
  coachWage: true,
  coachTax: true,
  paid: true,
  trainingSchedule: true,
  coach: true,
  amount: true,
  hoursCnt: true,
  sessionsCnt: true,
};

export const validatePayoutDTO = (p: PayoutDTO) => {
  const parsedWage = parseFloat(p.coachWage.toString());
  const parsedTax = parseFloat(p.coachTax.toString());
  return {
    id: true,
    year: true,
    month: true,
    coachWage: Number.isInteger(parsedWage) && p.coachWage >= 0,
    coachTax: Number.isInteger(parsedTax) && p.coachTax >= 0 && p.coachTax <= 100,
    paid: true,
    trainingSchedule: true,
    coach: true,
    amount: true,
    hoursCnt: true,
    sessionsCnt: true,
    };
};
